<template>
  <div>
    <div v-for="field in fields" v-bind:key="field.name" class="mt-4">
      <TextField
        v-if="field.type == 'text'"
        :field="field"
        :value="value[field.name]"
        @input="emitInput"
      />
      <TextArrayField
        v-if="field.type == 'textarray'"
        :field="field"
        :value="value[field.name]"
        @input="emitInput"
      />
      <TextareaField
        v-if="field.type == 'textarea'"
        :field="field"
        :value="value[field.name]"
        @input="emitInput"
      />
      <BooleanField
        v-if="field.type == 'boolean'"
        :field="field"
        :value="value[field.name]"
        @input="emitInput"
      />
    </div>
  </div>
</template>

<script>
import TextField from './TextField.vue';
import TextArrayField from './TextArrayField.vue';
import TextareaField from './TextareaField.vue';
import BooleanField from './BooleanField.vue';

export default {
  name: 'FormComponent',
  components: {
    TextField,
    TextArrayField,
    TextareaField,
    BooleanField,
  },
  methods: {
    emitInput(e) {
      this.$emit('input', {
        ...this.value,
        [e.target.name]: e.target.value,
      });
    },
  },
  props: {
    name: String,
    fields: Array,
    value: Object,
  },
};
</script>
